import script from "./LeaveAdminView.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaveAdminView.vue?vue&type=script&setup=true&lang=js"

import "./LeaveAdminView.vue?vue&type=style&index=0&id=152686df&lang=css"

const __exports__ = script;

export default __exports__